// Rules for the photo staff upload for a venue, shared so the upload screen and the API agree.
export const VENUE_PHOTO_MIN_WIDTH_PX = 1200;
export const VENUE_PHOTO_MIN_HEIGHT_PX = 675;
export const VENUE_PHOTO_ASPECT = 16 / 9;
export const VENUE_PHOTO_MAX_BYTES = 10 * 1024 * 1024;
// A small file can unpack to a huge image, so photos over this many pixels are refused.
export const VENUE_PHOTO_MAX_PIXELS = 25_000_000;
